import React, { useContext, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import SignupProgress from "../../Components/SignupProgress";
import HeightModal from "../../modals/HeightModal";
import WeightModal from "../../modals/WeightModal";
import { images } from "../../Assets/images";
import Calendar from "../../Components/Calender";
import { CalendarDays } from "lucide-react";

const CreateAccountScreen2 = () => {
  const {
    signupData,
    updateSignupData,
    createAccountScreenTwo,
    translatedLabels,
    logoUrl,
    showCalendar,
    setShowCalendar,
    calendarRef,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const [showWeightModal, setWeightModal] = useState(false);
  const [showHeightModal, setShowHeightModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    createAccountScreenTwo();
  };

  return (
    <>
      <section id="createAccountPage" className="login-section-bg">
        <div className="container-main">
          <div className="d-flex justify-content-center">
            <div className="app-logo">
              <img
                src={logoUrl || images.appLogo}
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.appLogo;
                }}
              />
            </div>
          </div>
          <div className="content-card">
            <SignupProgress currentStep={2} />
            <h3 className="mb-4 text-center">
              {authLabel?.create_new_account?.label_value ||
                "Create new account"}
            </h3>

            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group mb-2 position-relative" ref={calendarRef}>
                <label className="form-label">
                  {authLabel?.date_of_birth?.label_value || "Date of birth"}{" "}
                  <small>
                    (
                    {authLabel?.min_age_text?.label_value ||
                      "must be at least 18 years old"}
                    )
                  </small>
                  <span className="text-danger">*</span>
                </label>

                <div className="position-relative">
                  <div
                    className="form-control wrInputText pe-5"
                    onClick={() => setShowCalendar(!showCalendar)}
                    style={{ cursor: "pointer", backgroundColor: "#fff" }}
                  >
                    {signupData?.dob
                      ? new Date(signupData.dob).toLocaleDateString("en-GB")
                      : "Select date"}
                  </div>

                  <CalendarDays
                    size={18}
                    className="position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                    pointerEvents="none"
                  />
                </div>

                {showCalendar && (
                  <div
                    className="position-absolute bg-white mt-1"
                    style={{ zIndex: 1000 }}
                  >
                    <Calendar
                      mode="dob"
                      value={signupData?.dob}
                      onDateChange={(formattedDate) => {
                        updateSignupData("dob", formattedDate);
                        setShowCalendar(false);
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex justufy-content-between gap-3">
                <div className="form-group mb-2">
                  <label className="form-label">
                    {authLabel?.weight?.label_value || "Weight"}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control wrInputText"
                    placeholder={
                      authLabel?.enter_weight?.label_value || "Enter weight"
                    }
                    value={
                      signupData.weight && signupData.weightUnit
                        ? `${signupData.weight}\u00A0\u00A0${signupData.weightUnit}`
                        : ""
                    }
                    readOnly
                    onClick={() => setWeightModal(true)}
                  />
                </div>
                <div className="form-group mb-2">
                  <label className="form-label">
                    {authLabel?.height?.label_value || "Height"}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control wrInputText"
                      placeholder={
                        authLabel?.enter_height?.label_value || "Enter height"
                      }
                      value={
                        signupData.height && signupData.heightUnit
                          ? `${signupData.height}\u00A0\u00A0${signupData.heightUnit}`
                          : ""
                      }
                      readOnly
                      onClick={() => setShowHeightModal(true)}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">
                  {authLabel?.race?.label_value || "Race"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={signupData?.race}
                  onChange={(e) => updateSignupData("race", e.target.value)}
                >
                  <option value="">
                    {authLabel?.select_race?.label_value || "Select Race"}
                  </option>
                  <option value="White">
                    {authLabel?.white?.label_value || "White"}
                  </option>
                  <option value="Black">
                    {authLabel?.black?.label_value || "Black"}
                  </option>
                  <option value="Asian">
                    {authLabel?.asian?.label_value || "Asian"}
                  </option>
                  <option value="Other">
                    {authLabel?.other?.label_value || "Other"}
                  </option>
                  <option value="Prefer Not To Answer">
                    {authLabel?.prefer_not_to_answer?.label_value ||
                      "Prefer Not To Answer"}
                  </option>
                </select>
              </div>

              <div className="d-flex gap-4 align-items-baseline">
                <label className="form-label mb-0">
                  {authLabel?.gender_at_birth?.label_value ||
                    "Gender At Birth "}{" "}
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex gap-3 align-items-center">
                  <div className="custom-checkbox form-check p-0">
                    <input
                      type="radio"
                      id="male"
                      value="male"
                      name="gender"
                      checked={signupData?.gender === "male"}
                      onChange={(e) =>
                        updateSignupData("gender", e.target.value)
                      }
                    />
                    <label className="custom-label fw-semibold" htmlFor="male">
                      {authLabel?.male?.label_value || "Male"}
                    </label>
                  </div>
                  <div className="custom-checkbox form-check p-0">
                    <input
                      type="radio"
                      id="female"
                      value="female"
                      name="gender"
                      checked={signupData?.gender === "female"}
                      onChange={(e) =>
                        updateSignupData("gender", e.target.value)
                      }
                    />
                    <label
                      className="custom-label fw-semibold"
                      htmlFor="female"
                    >
                      {authLabel?.female?.label_value || "Female"}
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <button className="btn btn-primary">
                  {authLabel?.next?.label_value || "Next"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
      <WeightModal
        show={showWeightModal}
        onClose={() => setWeightModal(false)}
        initialWeight={signupData.weight}
        initialUnit={signupData.weightUnit}
        onSave={({ weight, weightUnit }) => {
          if (weightUnit === "kg") {
            if (weight < 20 || weight > 300) {
              window.showToast("error", "Weight must be between 20–300 kg.");
              return;
            }
          } else if (weightUnit === "lbs") {
            if (weight < 44 || weight > 661) {
              window.showToast("error", "Weight must be between 44–661 lbs.");
              return;
            }
          }
          updateSignupData("weight", weight);
          updateSignupData("weightUnit", weightUnit);
          setWeightModal(false);
        }}
      />
      <HeightModal
        show={showHeightModal}
        onClose={() => setShowHeightModal(false)}
        initialHeight={signupData.height}
        initialUnit={signupData.heightUnit}
        onSave={({ height, heightUnit }) => {
          if (heightUnit === "cm") {
            if (height < 100 || height > 250) {
              window.showToast("error", "Height must be between 100–250 cm.");
              return;
            }
          } else if (heightUnit === "feet") {
            if (height < 3.3 || height > 8.2) {
              window.showToast("error", "Height must be between 3.3–8.2 feet.");
              return;
            }
          }
          updateSignupData("height", height);
          updateSignupData("heightUnit", heightUnit);
          setShowHeightModal(false);
        }}
      />
    </>
  );
};

export default CreateAccountScreen2;
